import { PURCHASE_ORDER_OPEN_STATUS_IDS } from '@nudool/shared';

import type { PurchaseOrderWorkspaceQueue } from './purchase-order-workspace-queues.js';

/** The statuses each queue can hold — `null` where the queue constrains something other than status. */
export const PURCHASE_ORDER_QUEUE_ADMITTED_STATUSES = {
  late: PURCHASE_ORDER_OPEN_STATUS_IDS,
  dueThisWeek: PURCHASE_ORDER_OPEN_STATUS_IDS,
  all: null,
} as const satisfies Record<PurchaseOrderWorkspaceQueue, readonly number[] | null>;
